// extracted by mini-css-extract-plugin
module.exports =  {"headerRow":"headerRow__-PiC8","headerTitle":"headerTitle__3ftGj","headerSubTitle":"headerSubTitle__VHpq0"};